<template>
  <div :key="compKey">
    <template v-if="loaded">
      <div v-for="(stage,sid) in stages" :key="sid" class="stage ion-activable">
        <div style="display: flex; flex-direction: row; justify-content: space-between; border-bottom: 1px solid #ccc; padding-bottom: 1vh">
            <div><strong>Ngày xổ</strong>: {{ $moment(stage.draw_at).format("dddd HH:mm - DD/MM/YYYY") }}</div>
            <div><strong>Kỳ</strong>: {{ stage.name }}</div>
          </div>

          <div class="extra" style="margin-top: 5px">
            <div :class="stage.extra.big >= 13 ?'lgbig':(stage.extra.big >= 11 ? 'smbig': '')">LỚN&nbsp;<small>{{ stage.extra.big }}</small></div>
            <div :class="stage.extra.small == stage.extra.big ?'bigtie': ''">HÒA</div>
            <div :class="stage.extra.small >= 13 ?'lgsmall':(stage.extra.small >= 11 ? 'smsmall': '')">NHỎ&nbsp;<small>{{ stage.extra.small }}</small></div>
          </div>

          <div class="extra" style="margin-top: 5px">
            <div :class="stage.extra.even >= 15 ?'evenbig':(stage.extra.even >= 13 ? 'even': '')">CHẴN&nbsp;<small>{{ stage.extra.even }}</small></div>
            <div :class="stage.extra.even == 11 || stage.extra.even == 12 ?'even':''">
              CHẴN 11-12
            </div>
            <div :class="stage.extra.odd == stage.extra.even ?'eventie': ''">HÒA</div>
            <div :class="stage.extra.odd == 11 || stage.extra.odd == 12 ?'odd':''">
              LẺ 11-12
            </div>
            <div :class="stage.extra.odd >= 15 ?'oddbig':(stage.extra.odd >= 13 ? 'odd': '')">LẺ&nbsp;<small>{{ stage.extra.odd }}</small></div>
          </div>

          <div class="balls">
            <span v-for="(num, nid) in stage.results" :key="nid" class="ball">{{ num }}</span>
          </div>
      </div>
    </template>
    <template v-else>
      <div v-for="i in Math.min(5, limit)" :key="i" class="stage">
        <div style="display: flex; flex-direction: row; justify-content: space-between;">
          <div class="date">
            <ion-skeleton-text style="width: 30vw"></ion-skeleton-text>
          </div>
          <div>
            <ion-skeleton-text style="width: 15vw"></ion-skeleton-text>
          </div>
        </div>

        <div class="balls">
          <span v-for="j in 20" :key="j" class="fakeball" style="border: none;">
            <ion-skeleton-text style="width: 7vw;"></ion-skeleton-text>
          </span>
        </div>

        <div class="extra">
          <div>
            <ion-skeleton-text style="width: 10vw"></ion-skeleton-text>
          </div>
          <div>
            <ion-skeleton-text style="width: 10vw"></ion-skeleton-text>
          </div>
          <div>
            <ion-skeleton-text style="width: 10vw"></ion-skeleton-text>
          </div>
          <div>
            <ion-skeleton-text style="width: 10vw"></ion-skeleton-text>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .stage {
    padding: 2vw;
    border-bottom: 1px solid #ddd;
    .date {
      text-transform: capitalize;
    }
    &:first-child {
      .balls {
        .ball {
          background: #f60;
          color: #fff;
          border-color: #f60;
        }
      }
    }
    .balls {
      display: grid;
      grid-template-columns: repeat(10, auto);
      margin: 1vh;
      .ball, .fakeball {
        width: 7vw;
        height: 7vw;
        border-radius: 50%;
        border: 1px solid #aaa;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 3px;
      }
    }
    .extra {
      display: flex;
      flex-direction: row;
      justify-content: center;
      > div {
        margin-left:  2vw;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 0.5vw;
        color: #666;
        &.lgbig {
          background: #d87f27;
          border-color: #d87f27;
          color: #fff;
        }
        &.smbig {
          background: #94ffaf;
          border-color: #94ffaf;
          color: #222;
        }
        &.lgsmall {
          background: #d87f27;
          border-color: #d87f27;
          color: #fff;
        }
        &.smsmall {
          background: #94ffaf;
          border-color: #94ffaf;
          color: #222;
        }
        &.bigtie {
          background: #d87f27;
          border-color: #d87f27;
          color: #fff;
        }
        &.even {
          background: #d52a94;
          border-color: #d52a94;
          color: #fff;
        }
        &.eventie {
          background: #d52a94;
          border-color: #d52a94;
          color: #fff;
        }
        &.evenbig {
          background: #f00f41;
          border-color: #f00f41;
          color: #fff;
        }
        &.odd {
          background: #d52a94;
          border-color: #d52a94;
          color: #fff;
        }
        &.oddbig {
          background: #f00f41;
          border-color: #f00f41;
          color: #fff;
        }
      }
    }

  }
</style>

<script>
  import { defineComponent } from 'vue';
  import {
    IonSkeletonText,
  } from '@ionic/vue';

  export default defineComponent({
    props: {
      limit: {
        type: Number,
        default: 100,
      },
      stage: {
        type: Number,
        default: 0,
      }
    },
    name: "KenoResults",
    components: {
      IonSkeletonText,
    },
    data() {
      return {
        loaded: false,
        compKey: 0,
        stages: [],
      }
    },
    mounted() {
      setTimeout(async () => {
        const params = { 'game': "keno", 'limit': this.limit };
        if (this.stage) params.stage = this.stage;
        const resp = await this.$utils.callAPI("GET", "/stages/results", params, false);
        console.log(resp);
        resp.data.stages.forEach((stage) => {
          stage.results = JSON.parse(stage.results).numbers;

          const extra = {
            big: 0,
            small: 0,
            odd: 0,
            even: 0,
          }

          stage.results.forEach((num) => {
            if (num > 40) {
              extra.big += 1;
            } else {
              extra.small += 1;
            }

            if (num % 2 == 0) {
              extra.even += 1;
            } else {
              extra.odd += 1;
            }
          });
          stage.extra = extra;
        });
        this.stages = resp.data.stages;
        this.loaded = true;
        this.compKey++;
      },1000);
    },
  })
</script>

